import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.pl.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
import { validatePolish } from 'validate-polish';
import IBAN from 'iban';
import './files';

$.fn.datepicker.defaults.language = "pl";
$.fn.datepicker.defaults.format = "dd.mm.yyyy";
$.fn.datepicker.defaults.clearBtn = true;
$.fn.datepicker.defaults.defaultViewDate = new Date();
$.fn.datepicker.defaults.maxViewMode = 'decade';
$.fn.datepicker.dates.pl.monthsTitle = 'Miesiące';

$('input[data-type=datepicker]').datepicker();

$('input[data-type=pesel]').addRuleValidator('pesel', input => validatePolish.pesel(input.value));
$('input[data-type=nip]').addRuleValidator('nip', input => validatePolish.nip(input.value));
$('input[data-type=iban]').addRuleValidator('iban', input => IBAN.isValid(input.value));